import type { Level, SmartConfiguration } from "types";

export const isAddFavouriteVisible = (
  isHeroBanner:boolean,
  smartConfiguration: SmartConfiguration | null,
  rootId: number | null,
  courseId: number | null,
  learningObjectTypology: Level,
  simple:boolean,
  isBookmarkPage: boolean,
  isEditorial?: boolean,
  isExplorePage?: boolean,
  isCard?: boolean
) =>{
  //HERO BANNER

  // button preferiti visibile solo per le card e heroBanner
  if (!isCard && !isHeroBanner) {
    return false;
  }

  if(
    isHeroBanner
    && smartConfiguration?.funcFavourites
    && ((!rootId || learningObjectTypology === "PATH")
    && (!courseId || learningObjectTypology === "COURSE"))
  ){
    return true;
  }
  //CARDs
  if(
    !isHeroBanner
    && (!simple || isBookmarkPage || isExplorePage)
    && !isEditorial
    && smartConfiguration?.funcFavourites
    && (!rootId && !courseId)
  ) {
    return true;
  }

  return false;
};
